/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reload_ProxyInputs */



/**
* | output |
* | --- |
* | "Reload Proxy" |
*
* @param {Reload_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reload_proxy = /** @type {((inputs?: Reload_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reload_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recharger le proxy")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy neu laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricarica proxy")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезагрузить прокси")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recargar proxy")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重新加载代理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシをリロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी को पुनः लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recarregar proxy")
	return /** @type {LocalizedString} */ ("Reload Proxy")
});